import SelectBox from '@components/SelectBox';
import { Trans, useTranslation } from 'react-i18next';
import { type IPagination } from './Pagination';

export const PaginationMobile = ({ dat, pageGo }: { dat: IPagination; pageGo: (pageNum: string) => void }) => {
    if (!dat || dat.lastPage < 2) return null;

    const { t } = useTranslation();
    const onPrev = () => pageGo(Math.max(dat.page - 1, 1).toString());
    const onNext = () => pageGo(Math.min(dat.page + 1, dat.lastPage).toString());

    const selectOptions = Array.from({ length: dat.lastPage }).map((key, i) => ({
        label: (i + 1).toString(),
        value: (i + 1).toString(),
    }));

    return (
        <div className="ui-pagination is-mobile">
            <div className="pagination-list">
                <button onClick={onPrev} className={`prev ${dat.page < 2 ? 'is-disabled' : ''}`} title="Prev">
                    <span>{t('price.prev')}</span>
                </button>
                <button onClick={onNext} className={`next ${dat.page >= dat.lastPage ? 'is-disabled' : ''}`} title="Next">
                    <span>{t('price.next')}</span>
                </button>
            </div>
            <div className="pagination-select">
                <div className="pagination-select-page">
                    <SelectBox selectList={selectOptions} activeSelectId={dat.page.toString()} paramKey="page" />
                </div>
                <div className="pagination-total">
                    <Trans>{t('price.page').replace('{N}', dat.lastPage.toString())}</Trans>
                </div>
            </div>
        </div>
    );
};
